import { render, staticRenderFns } from "./ssr-manage-search.vue?vue&type=template&id=c9b8df34"
import script from "./ssr-manage-search.vue?vue&type=script&lang=js"
export * from "./ssr-manage-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b8df34')) {
      api.createRecord('c9b8df34', component.options)
    } else {
      api.reload('c9b8df34', component.options)
    }
    module.hot.accept("./ssr-manage-search.vue?vue&type=template&id=c9b8df34", function () {
      api.rerender('c9b8df34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/ssr-manage-search.vue"
export default component.exports